import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportWindowComponent } from '@ipg/ngx-frontend-toolset';

@Component({
  selector: 'app-lib-error-report',
  imports: [ReportWindowComponent],
  templateUrl: './lib-error-report.component.html',
  styleUrl: './lib-error-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibErrorReportComponent {}
